/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuardService } from "../shared/services/auth-guard.service";
import { RastreamentoConfiguracaoComponent } from "./configuracao/rastreamento-configuracao.component";
import { configuracaoRoute } from "../shared/services/data.service";
import {RastreamentoMapaComponent} from "./rastreamento-mapa/rastreamento-mapa.component";
import {RastreamentoVeiculosComponent} from "./rastreamento-veiculos/rastreamento-veiculos.component";
import {RastreamentoHistoricoComponent} from "./rastreamento-historico/rastreamento-historico.component";
import {ModelosGpsComponent} from "./modelos-gps/modelos-gps.component";
import {modeloGpsRoute} from "./modelos-gps/shared/data.service";
import {modeloGpsRoutes} from "./modelos-gps/modelos-gps-routing.module";
import {RastreamentoMapa2Component} from "./rastreamento-mapa2/rastreamento-mapa2.component";
import {cercaRoute} from "./cercas/shared/data.service";
import {CercasComponent} from "./cercas/cercas.component";
import {cercaRoutes} from "./cercas/cercas-routing.module";
import {alarmeRoute} from "./alarmes/shared/data.service";
import {AlarmesComponent} from "./alarmes/alarmes.component";
import {alarmeRoutes} from "./alarmes/alarmes-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class RastreamentosRoutingModule {}

export const rastreamentosRoutes: any[] = [
    {
        path: '',
        redirectTo: '/mapa',
        pathMatch: 'full'
    },{
        path: configuracaoRoute,
        component: RastreamentoConfiguracaoComponent,
        canActivate: [AuthGuardService]
    },{
        path: configuracaoRoute + '/' + modeloGpsRoute,
        component: ModelosGpsComponent,
        canActivate: [AuthGuardService],
        children: modeloGpsRoutes
    },{
        path: configuracaoRoute + '/' + cercaRoute,
        component: CercasComponent,
        canActivate: [AuthGuardService],
        children: cercaRoutes
    },{
        path: configuracaoRoute + '/' + alarmeRoute,
        component: AlarmesComponent,
        canActivate: [AuthGuardService],
        children: alarmeRoutes
    },{
        path: 'mapa',
        component: RastreamentoMapaComponent,
        canActivate: [AuthGuardService],
    },{
        path: 'mapa2',
        component: RastreamentoMapa2Component,
        canActivate: [AuthGuardService],
    },{
        path: 'veiculos',
        component: RastreamentoVeiculosComponent,
        canActivate: [AuthGuardService],
    },{
        path: 'veiculos/:id',
        component: RastreamentoHistoricoComponent,
        canActivate: [AuthGuardService],
    }
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamentos-routing.module.ts
 **/